import React from 'react';

import { LocationData } from '../../map.interfaces';

export interface IMapPopupProps {
  locationData: LocationData;
}

export interface IProperyElement {
  property: string;
  locationData: LocationData;
}

const StandardPopup = ({ locationData }: IMapPopupProps) => {
  const body = locationData.propertiesForLayer?.body || '';

  return (
    <div className="map-popup-standard">
      <div
        dangerouslySetInnerHTML={{
          __html: body,
        }}
      />
    </div>
  );
};

export default StandardPopup;
